import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {Page} from '@/hooks/empresa/organizacion/use-businesses'
import type {components} from '@/lib/api-schema'

type SolicitudSstTenant = components['schemas']['SolicitudSstTenantRead']
type SolicitudSstEnvelope = components['schemas']['SolicitudSstTenantEnvelope']
export type SolicitudSstAdmin = components['schemas']['SolicitudSstAdminRead']

export const SOLICITUDES_SST_PAGE_SIZE = 10

export function useSolicitudSst(businessId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['solicitud-sst', businessId],
    queryFn: async () =>
      (await api.get<SolicitudSstEnvelope>(`/businesses/${businessId}/sgsst/solicitud-sst`)).data.solicitud,
    enabled: enabled && !!businessId,
  })
}

export function useSolicitarSst(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (nota: string | null) =>
      (await api.post<SolicitudSstTenant>(`/businesses/${businessId}/sgsst/solicitudes-sst`, {nota})).data,
    onSuccess: () => queryClient.invalidateQueries({queryKey: ['solicitud-sst', businessId]}),
  })
}

export function useSolicitudesSstAdmin(page: number, enabled: boolean) {
  return useQuery({
    queryKey: ['admin-solicitudes-sst', page],
    queryFn: async () =>
      (
        await api.get<Page<SolicitudSstAdmin>>('/admin/solicitudes-sst', {
          params: {page, page_size: SOLICITUDES_SST_PAGE_SIZE},
        })
      ).data,
    enabled,
    placeholderData: (previous) => previous,
  })
}

export function usePatchSolicitudSst() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (input: {solicitudId: string; action: 'atender' | 'descartar'; motivo?: string}) =>
      (
        await api.patch<SolicitudSstAdmin>(`/admin/solicitudes-sst/${input.solicitudId}`, {
          action: input.action,
          motivo: input.motivo ?? null,
        })
      ).data,
    onSuccess: () => queryClient.invalidateQueries({queryKey: ['admin-solicitudes-sst']}),
  })
}
